import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { FormAction, formValueSelector } from 'redux-form'
import { translate } from 'loankeeper-common/helpers'
//@ts-ignore
import LKButton from 'shared/LKButton'

const OfficalCCYButton: FC<{
  change: (key: string, value: any) => FormAction
  FormName: string
  disabled?: boolean
}> = (props) => {
  const { change, FormName, disabled } = props

  const formSelector = formValueSelector(FormName)

  const isDisabled = useSelector(
    (state) =>
      disabled ||
      formSelector(state, 'alreadyDefinedRates') === '0' ||
      (formSelector(state, 'debitCCY') !== 'GEL' && formSelector(state, 'creditCCY') !== 'GEL'),
  )

  return (
    <LKButton
      onClick={() => change('CCYRateType', 'offical')}
      alias="client"
      style={{ width: '186px', height: '33px' }}
      disabled={isDisabled}
    >
      {translate('frm_acc_conv_add-cmd_official_rate')}
    </LKButton>
  )
}

export default OfficalCCYButton
